import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LANGS } from "../i18n";

export function LanguageSwitcher({ variant = "desktop" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  useEffect(() => {
    const onClick = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-white/70 hover:text-white transition-colors px-2 py-1.5"
        data-testid="lang-switcher"
        aria-label="Change language"
      >
        <Globe size={16} />
        <span className="uppercase">{current.code}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          className={`absolute mt-2 w-44 rounded-xl border border-white/10 bg-navy-800 shadow-2xl overflow-hidden z-50 ${
            variant === "desktop" ? "end-0" : "start-0"
          }`}
          data-testid="lang-menu"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => choose(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`flex items-center justify-between w-full px-4 py-2.5 text-sm transition-colors hover:bg-white/5 ${
                l.code === current.code ? "text-white" : "text-white/65"
              }`}
            >
              <span className="flex items-center gap-2.5">
                <span>{l.flag}</span>
                {l.label}
              </span>
              {l.code === current.code && <Check size={15} className="text-signal" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
